import { memo, useEffect, useState } from 'react';
import { QueryBuilder } from 'react-querybuilder';
import 'react-querybuilder/dist/query-builder.scss';

import { QueryBuilderAntD } from '@react-querybuilder/antd';

import AddGroupComponent from './AddGroupComponent';
import AddRuleComponent from './AddRuleComponent';
import CombinatorSelector from './CombinatorSelector';
import RemoveConditionComponent from './RemoveConditionComponent';
import RemoveGroupComponent from './RemoveGroupComponent';
import { COMBINATORS } from './constants';
import './styles.scss';

function AppQueryBuilder({ defaultQuery, fields, handleQueryChange }) {
  const [query, setQuery] = useState(defaultQuery);

  useEffect(() => {
    setQuery(defaultQuery);
  }, []);

  function handleChange(query) {
    setQuery(query);
    handleQueryChange(query);
  }

  return (
    <QueryBuilderAntD>
      <QueryBuilder
        combinators={COMBINATORS}
        controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
        controlElements={{
          addGroupAction: props => (props.level === 0 ? <AddGroupComponent {...props} /> : null),
          addRuleAction: AddRuleComponent,
          removeRuleAction: RemoveConditionComponent,
          removeGroupAction: RemoveGroupComponent,
          combinatorSelector: CombinatorSelector
        }}
        fields={fields}
        query={query}
        onQueryChange={handleChange}
      />
    </QueryBuilderAntD>
  );
}

export default memo(AppQueryBuilder);
